import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

const KEY = 'ow-cookie-consent';
export const COOKIE_SETTINGS_EVENT = 'ow-open-cookie-settings';

export const openCookieSettings = () => window.dispatchEvent(new Event(COOKIE_SETTINGS_EVENT));

const read = () => {
  try { return window.localStorage.getItem(KEY); } catch { return null; }
};

export const ConsentBanner = () => {
  const [open, setOpen] = useState(() => !read());

  useEffect(() => {
    const show = () => setOpen(true);
    window.addEventListener(COOKIE_SETTINGS_EVENT, show);
    return () => window.removeEventListener(COOKIE_SETTINGS_EVENT, show);
  }, []);

  const choose = (value) => {
    try { window.localStorage.setItem(KEY, value); } catch { /* storage blocked */ }
    if (value === 'analytics' && typeof window.OW_POSTHOG_INIT === 'function') {
      window.OW_POSTHOG_INIT();
    }
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 px-space-sm sm:px-margin-mobile lg:px-margin pb-space-sm sm:pb-space-md" data-testid="consent-banner">
      <div className="max-w-5xl mx-auto p-space-sm sm:p-space-lg rounded-lg bg-primary-container border-l-4 border-surface-tint shadow-[0_8px_24px_rgba(17,19,23,0.12)]">
        <div className="flex flex-col lg:flex-row lg:items-center gap-space-sm sm:gap-space-md">
          <div className="flex items-start gap-space-sm sm:gap-space-md flex-1">
            <Icon name="verified" className="text-surface-tint mt-0.5 sm:mt-1 text-[18px] sm:text-[24px] shrink-0" />
            <p className="font-body-sm text-body-sm sm:font-body-md sm:text-body-md text-on-surface-variant leading-relaxed">
              We use essential cookies to keep the site working. With your permission, we’d also like to use analytics
              to see which guides are helpful. We never sell your data or use it for advertising.{' '}
              <Link
                to="/privacy"
                data-testid="consent-privacy-link"
                className="text-surface-tint font-semibold hover:text-primary transition-colors"
              >
                Privacy Policy
              </Link>
            </p>
          </div>
          <div className="flex flex-row gap-space-xs sm:gap-space-sm shrink-0">
            <button
              type="button"
              data-testid="consent-essential-button"
              onClick={() => choose('essential')}
              className="flex-1 lg:flex-none inline-flex items-center justify-center px-space-md sm:px-space-lg h-9 sm:h-10 rounded-lg bg-surface-container-low text-outline font-label-md text-label-md uppercase tracking-wider hover:bg-surface-container transition-colors"
            >
              Only essential
            </button>
            <button
              type="button"
              data-testid="consent-analytics-button"
              onClick={() => choose('analytics')}
              className="flex-1 lg:flex-none inline-flex items-center justify-center px-space-md sm:px-space-lg h-9 sm:h-10 rounded-lg bg-surface-tint text-on-primary font-label-md text-label-md uppercase tracking-wider shadow-[0_4px_16px_rgba(240,40,223,0.25)] hover:bg-primary transition-all"
            >
              Accept analytics
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
